import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Card, Spinner } from 'react-bootstrap';
import { api } from '../../lib/api';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../context/ToastContext';
import FormCliente from './FormCliente';
import TabelaImoveis from '../imoveis/TabelaImoveis';
import DetalheImovel from '../imoveis/DetalheImovel';

// Imóveis onde este cliente é o PROPRIETÁRIO (`i1_codproprietario`) — pedido do Jason,
// 22/10/2026: "ao entrar no cadastro do cliente, ver os imóveis vinculados a ele". Só busca
// depois que o cliente já existe (não faz sentido num cadastro novo, sem public_id ainda).
function ImoveisVinculados({ clientePublicId }) {
  const { usuario } = useAuth();
  const [imoveis, setImoveis] = useState(null);
  const [aberto, setAberto] = useState(null);

  useEffect(() => {
    api
      .get(`/imoveis?proprietario_id=${clientePublicId}&per_page=100`)
      .then((r) => setImoveis(r.data))
      .catch(() => setImoveis([])); // best-effort — não trava a tela do cliente por isso
  }, [clientePublicId]);

  if (imoveis === null) return <Spinner animation="border" size="sm" />;
  if (imoveis.length === 0) return null; // sem imóvel vinculado: nem mostra o card

  return (
    <Card className="mt-4">
      <Card.Header>Imóveis deste proprietário ({imoveis.length})</Card.Header>
      <Card.Body className="p-0">
        <TabelaImoveis imoveis={imoveis} usuario={usuario} aoAbrir={setAberto} />
      </Card.Body>
      <DetalheImovel publicId={aberto} aoFechar={() => setAberto(null)} aoExcluido={() => setAberto(null)} />
    </Card>
  );
}

export default function PaginaCliente() {
  const { publicId } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const ehNovo = !publicId;
  const [cliente, setCliente] = useState(null);
  const [carregando, setCarregando] = useState(!ehNovo);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    if (ehNovo) return;
    api
      .get(`/clientes/${publicId}`)
      .then((r) => setCliente(r.data))
      // Achado em auditoria 2026-09-18: sem `.catch`, uma falha (rede,
      // sessão expirada, publicId inválido) deixava `cliente` em `null`
      // sem aviso — o formulário renderizava TODO EM BRANCO (sob o
      // título "Editar cliente"), e ao salvar, `paraApi` manda TODOS os
      // ~40 campos (inclusive os em branco, virando `null`) — ou seja,
      // "editar e salvar" nesse cenário na prática APAGAVA os dados reais
      // do cliente em vez de atualizar só o que foi digitado. Mostrar o
      // erro em vez do formulário vazio evita esse apagamento silencioso.
      .catch((err) => {
        setErro(true);
        toast.erro(err.message || 'Não foi possível carregar o cliente');
      })
      .finally(() => setCarregando(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [publicId, ehNovo]);

  async function salvar(dados) {
    if (ehNovo) {
      await api.post('/clientes', dados);
      toast.sucesso('Cliente criado com sucesso.');
    } else {
      await api.put(`/clientes/${publicId}`, dados);
      toast.sucesso('Cliente atualizado com sucesso.');
    }
    navigate('/clientes');
  }

  return (
    <>
      <h1 className="h4 mb-4">{ehNovo ? 'Novo cliente' : 'Editar cliente'}</h1>
      {carregando ? (
        <Spinner animation="border" />
      ) : (
        !erro && (
          <>
            <FormCliente clienteInicial={cliente} aoSalvar={salvar} />
            {!ehNovo && <ImoveisVinculados clientePublicId={publicId} />}
          </>
        )
      )}
    </>
  );
}
